interface ZDTicketInterface {
  subject: string;
  comment: {
    body: string;
  };
  status: string;
  requester: {
    name: string;
    email: string;
  };
  group_id: number;
}

export interface TicketObj {
  Name: string;
  Patient: string;
  Facility: string;
  Company: string;
  Description: string;
}

export class ZDTicket {
  ticket: ZDTicketInterface;

  constructor(subject: string, body: string, name: string, email: string) {
    this.ticket = {
      subject: subject,
      comment: {
        body: body
      },
      status: "new",
      requester: {
        name: name,
        email: email
      },
      //ID points to TIER 1 SUPPORT category on Zendesk
      group_id: 24796319397780
    };
  }
}
